// React
import React, { useState, useLayoutEffect, useRef } from 'react';

// Prop types
import PropTypes from 'prop-types';

// Component
import classnames from 'classnames';

// Const
import { MANAGER } from '../../../const';

// Mui styles
import { withStyles, MuiThemeProvider, createTheme } from '@material-ui/core/styles';

// Mui core
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';

// Icon
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

const styles = () =>
	({
		root : {
			display        : 'flex',
			justifyContent : 'space-between'
		},
		cardBox : {
			width  : '47%',
			margin : '0 1.5%'
		},
		cardInfo : {
			display        : 'flex',
			justifyContent : 'space-between',
			width          : '100%',
			color          : '#999898',
			borderBottom   : '1px solid #999898',
			marginBottom   : '10%',
			paddingBottom  : '0.3rem',
			alignItems     : 'end'
		},
		cardText : {
			color         : '#999898',
			marginBottom  : '2rem',
			display       : 'flex',
			flexDirection : 'column',
			width         : '100%'
		},
		titleLabel : {
			width : '2.25rem'
		},
		titleValue : {
			width        : 'calc(100% - 2.25rem)',
			overflowWrap : 'break-word',
			fontSize     : '0.9rem'
		},
		value : {
			width        : '100%',
			overflowWrap : 'break-word',
			fontSize     : '0.9rem'
		},
		titleShort : {
			minWidth    : '2rem',
			marginRight : '0.2rem'
		},
		titleLong : {
			minWidth    : '3.5rem',
			marginRight : '0.2rem'
		},
		valueLong : {
			minWidth     : '7rem',
			overflowWrap : 'break-word',
			textAlign    : 'start'
		},
		cardTitle : {
			border         : '1px solid white',
			borderRadius   : '0.4rem',
			color          : 'white',
			display        : 'flex',
			justifyContent : 'space-between',
			marginBottom   : '20%'
		},
		cardManagerInfo : {
			background : '#9ec317'
		},
		cardMemberInfo : {
			background : '#e97f00'
		},
		cardManagerTitle : {
			padding : '0.5rem 0.8rem'
		},
		borderRight : {
			borderRight : '2px solid white'
		},
		arrowDropUpIcon : {
			transform : 'rotate(90deg)'
		},
		arrowDropDownIcon : {
			transform : 'rotate(-90deg)'
		},
		showMoreBtn : {
			background   : 'white',
			border       : '1px solid #999898',
			borderRadius : '0.3rem',
			color        : '#999898',
			width        : '7rem',
			padding      : '0.1rem 0.5rem',
			fontSize     : '0.8rem',
			marginTop    : '2rem'
		},
		alignTop : {
			alignItems : 'start'
		}
	});

const theme = createTheme({
	overrides : {
		MuiButton : {
			startIcon : {
				marginRight : '0'
			}
		}
	}
});

const MemoCardContent = ({
	classes,
	cardType,
	detail
}) =>
{

	// Collapse card details
	const [ isShowMore, setIsShowMore ] = useState(false);
	// Check if show more button is displayed
	const [ checkShowMore, setCheckShowMore ] = useState(false);
	// Get properties of text 対応者 内田沙耶
	const cardTextRef = useRef(null);

	const isHost = cardType === MANAGER;

	const getDateString = (timestamp) =>
	{
		const date = timestamp ? new Date(timestamp) : new Date();
		const month = (`0${date.getMonth() + 1}`).slice(-2);
		const day = (`0${date.getDate()}`).slice(-2);
		const hour = (`0${date.getHours()}`).slice(-2);
		const min = (`0${date.getMinutes()}`).slice(-2);

		return `${date.getFullYear()}/${month}/${day} ${hour}:${min}`;
	};

	const getTalkTimeString = (duration) =>
	{
		if (duration)
		{
			const seconds = parseInt(duration);

			const min = (`${parseInt(seconds/60)}`);
			const sec = (`0${parseInt(seconds%60)}`).slice(-2);

			return `${min}分${sec}秒`;
		}
		else
		{
			return '0秒';
		}
	};

	useLayoutEffect(() =>
	{
		const { clientHeight = 0 } = cardTextRef?.current;

		if (clientHeight > 210)
		{
			setCheckShowMore(true);
		}
	}, [ setCheckShowMore ]);

	return (
		<MuiThemeProvider theme={theme}>
			<Box className={classes.root}>
				<Box className={classes.cardBox}>
					<Box className={classnames(
						classes.cardTitle,
						isHost ? classes.cardManagerInfo : classes.cardMemberInfo
					)}
					>
						<p className={`${classes.cardManagerTitle} ${classes.borderRight}`}>
							{isHost ? '担当者' : '対応者'}
						</p>
						<p className={classes.cardManagerTitle}>
							{detail.user}
						</p>
					</Box>
					<Box className={classes.cardInfo}>
						<p className={classes.titleShort}>日付</p>
						<p className={classes.value}>{getDateString(detail.timestamp)}</p>
					</Box>
					{isHost &&
						<>
							<Box className={classes.cardInfo}>
								<p className={classes.titleShort}>名前</p>
								<p className={classes.value}>{detail.name}</p>
							</Box>

							{
								(detail.guestInput1?.type !== 'phone' && detail.guestInput2?.type !== 'phone') &&
								<Box className={classes.cardInfo}>
									<p className={classes.titleLong}>連絡先</p>
									<p className={classes.value}>{detail.sms}</p>
								</Box>
							}

							{
								(detail.guestInput1?.type !== 'email' && detail.guestInput2?.type !== 'email') &&
								<Box className={classes.cardInfo}>
									<p className={classes.titleLong}>eメール</p>
									<p className={`${classes.value} ${classes.valueLong}`}>{detail.email}</p>
								</Box>
							}

							{
								detail.guestInput1?.key &&
								<Box className={classes.cardInfo}>
									<p className={classes.titleLong}>{detail.guestInput1.key}</p>
									<p className={classes.value}>{detail.guestInput1.value}</p>
								</Box>
							}

							{
								detail.guestInput2?.key &&
								<Box className={classes.cardInfo}>
									<p className={classes.titleLong}>{detail.guestInput2.key}</p>
									<p className={classes.value}>{detail.guestInput2.value}</p>
								</Box>
							}

							<Box className={classes.cardInfo}>
								<p className={classes.titleLong}>通話時間</p>
								<p className={classes.value}>{getTalkTimeString(detail.duration)}</p>
							</Box>
						</>
					}
				</Box>
				<Box className={classes.cardBox}>
					<Box className={classes.cardInfo}>
						<p className={classes.titleLabel}>内容</p>
						<p className={classes.titleValue}>{detail.title}</p>
					</Box>
					<Box className={classes.cardText}>
						<Collapse in={isShowMore} collapsedSize={210}>
							<p ref={cardTextRef} className={classes.value}>{detail.message}</p>
						</Collapse>
						{checkShowMore &&
							<Button
								className={classnames(
									classes.showMoreBtn,
									isShowMore ? null : classes.alignTop
								)}
								startIcon={
									<PlayArrowIcon
										className={
											classnames(
												isShowMore ?
													classes.arrowDropDownIcon :
													classes.arrowDropUpIcon
											)
										}
									/>
								}
								onClick={() => setIsShowMore(!isShowMore)}
							>
								{isShowMore ? '閉じる' : '詳細を表示'}
							</Button>
						}
					</Box>
				</Box>
			</Box>
		</MuiThemeProvider>
	);
};

MemoCardContent.propTypes =
{
	classes  : PropTypes.object.isRequired,
	cardType : PropTypes.string.isRequired,
	detail   : PropTypes.object.isRequired
};

export default withStyles(styles)(MemoCardContent);
